import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const SuccessPageWithEmailStyles = styled(OnboardingPage)`
  body.dark & {
    --success-payment-next-actions-border-bottom: 1px solid #331e31;
  }

  --success-payment-next-actions-border-bottom: 1px solid #fff;
  padding: 20px 0 0;

  ion-content {
    position: relative;

    .info-protection {
      background: #583155;
      border: none;
      margin: 24px 0 0;
    }
  }

  .success-payment-with-email-title {
    padding: 24px 16px 0;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0 0 24px;
  }

  .img-container {
    top: 90px;
    left: 50%;
    max-width: 300px;
    width: 100%;
    margin: 0 auto;
    position: relative;

    &-content {
      position: absolute;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .content {
    width: 100%;
    padding: 0 24px 0;
  }
`;

export const MainBlockStyles = styled.div`
  max-width: 300px;
  height: 350px;
  width: 100%;
  margin: 0 auto 16px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const MainBlockContentStyles = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -10px;
    height: 4px;
    width: 100%;
    border-radius: 4px;
    background: linear-gradient(136deg, #7f36f3 -3.67%, #ed0d80 106.36%);
  }
`;

export const MainBlockPhraseStyles = styled(UiTypography)`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  aspect-ratio: 2.08;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
